import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { ErrorBoundary } from './ErrorBoundary.tsx';
import './index.css';

console.log('main.tsx executing...');

// Change the page title to confirm JavaScript is running
document.title = 'JS WORKING - AI Content Optimizer';

const rootElement = document.getElementById('root');
console.log('Root element found:', rootElement);

if (rootElement) {
  console.log('Creating React root...');
  document.title = 'REACT MOUNTING - AI Content Optimizer';
  
  // Add immediate fallback content
  rootElement.innerHTML = '<div style="padding: 20px; background: #fef3c7; border: 2px solid #f59e0b; font-size: 20px;"><h1>🟡 JavaScript is executing...</h1><p>Attempting to mount React...</p></div>';
  
  try {
    const root = ReactDOM.createRoot(rootElement);
    console.log('React root created, rendering...');
    document.title = 'REACT RENDERING - AI Content Optimizer';
    
    root.render(
      <ErrorBoundary>
        <StrictMode>
          <App />
        </StrictMode>
      </ErrorBoundary>
    );
    console.log('React render called successfully');
    
    // Change title after successful render
    setTimeout(() => {
      document.title = 'REACT SUCCESS - App Rendered!';
    }, 100);
  } catch (error) {
    console.error('Error rendering React app:', error);
    document.title = 'REACT ERROR - AI Content Optimizer';
    rootElement.innerHTML = `<div style="padding: 20px; background: #fee2e2; color: #dc2626; font-size: 20px;"><h1>🔴 React Render Error</h1><p>${error}</p></div>`;
  }
} else {
  console.error('Root element not found!');
  document.title = 'NO ROOT ELEMENT - AI Content Optimizer';
  document.body.innerHTML = '<div style="padding: 20px; background: #fee2e2; color: #dc2626; font-size: 20px;"><h1>🔴 Root Element Missing</h1><p>Could not find #root element</p></div>';
}